<template>
  <div>
    <el-select
        v-model="materialType"
        :style="{width: width}"
        placeholder="请选择物料分类"
        clearable
        filterable
    >
      <el-option
          v-for="item in materialTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      />
    </el-select>
    <el-select
        v-model="selectedValue"
        :style="{width: width}"
        placeholder="请选择物料"
        clearable
        filterable
    >
      <el-option
          v-for="item in getSelectedValue()"
          :disabled="!materialType"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'MaterialLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      materialList: [],
      selectedValue: this.value,
      materialType: null,
      materialTypeList: []
    }
  },
  watch: {
    selectedValue(newVal) {
      this.selectedValue = newVal
      const selectedMaterial = this.materialList?.find(item => item.id === newVal);
      if(selectedMaterial){
        this.$emit('callBack', {
          id: selectedMaterial?.id,
          name: selectedMaterial?.name
        });
      }
    },
    value(newVal) {
      if(newVal && newVal !== this.selectedValue){
        this.selectedValue = newVal
      }
    }
  },
  mounted() {
    this.fetchMaterialList()
  },
  methods: {
    async fetchMaterialList() {
      try {
        const res = await requestTicket.post('/Ticketing/material/findAll')
        this.materialList = res.data || []
      } catch (error) {
        console.error('获取物料列表失败:', error)
      }
      try {
        const typeRes = await requestTicket.post('/Ticketing/material-type/findAll')
        this.materialTypeList = typeRes.data || []
      } catch (error) {
        console.error('获取物料列表失败:', error)
      }
    },
    getSelectedValue() {
      return this.materialList.filter(item => {
        return !this.materialType || item.materialTypeId === this.materialType
      })
    }
  }
}
</script>